// @flow

import * as React from 'react';

import { ListRow, ListItem, ListCell, ListLoader } from '@gandi/ui/deprecated';

type Props = {
  message: string,
};

export default class ListSpinner extends React.PureComponent<Props> {
  render(): React.Node {
    return (
      <ListRow separatorBottom>
        <ListItem highlight="placeholder">
          <ListCell>{this.props.message}</ListCell>
          <ListLoader />
        </ListItem>
      </ListRow>
    );
  }
}
